import * as React from "react";
import { formatMoney } from "../../../react-core/Utils/Money";
import { Money } from "../../../Wrap/Core/DataTypes/Money";

interface IMoneyDisplayWithUpperNominalProps {
  amount: Money;
}

const MoneyDisplayWithUpperDecimal = (props: IMoneyDisplayWithUpperNominalProps) => {
  const [wholeNumber, decimalNumber] = formatMoney(props.amount).split(".");

  return (
    <div className="amount">
      {wholeNumber}
      <span className="decimal-place">.{decimalNumber}</span>
    </div>
  )
}

export default MoneyDisplayWithUpperDecimal;